import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { isTokenValid } from "../../../Utils/authUtils";

const ProtectedRoute = ({ children }) => {
  return isTokenValid() ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;